import { Component, OnInit, Input } from '@angular/core';
import { Router }              from '@angular/router';

import { Size }            from '../data/formData.model';
import { FormDataService }     from '../data/formData.service';
import {FormControl, Validators, FormGroup, FormBuilder} from '@angular/forms';

@Component({
  selector: 'app-art-haus-step2',
  templateUrl: './art-haus-step2.component.html',
  styleUrls: ['./art-haus-step2.component.scss']
})
export class ArtHausStep2Component implements OnInit {

  title = 'Bitte wählen Sie die Wohn- und Grundstücksfläche';
  form: any;
  size: Size;

  autoTicks = false;
  disabled = false;
  invert = false;
  max = 500;
  min = 50;
  max2 = 2500;
  min2 = 100;
  showTicks = false;
  step = 1;
  thumbLabel = true;
  vertical = false;
  offsetWidth: number;
  testForm: FormGroup;


  allowedChars = new Set('0123456789'.split('').map(c => c.charCodeAt(0)));

  check(event: KeyboardEvent) {
 
    // 31 and below are control keys, don't block them.
    if (event.keyCode > 31 && !this.allowedChars.has(event.keyCode)) {
      event.preventDefault();
    }
  }

  @Input() scrWidth: number;

  constructor(private router: Router, private formDataService: FormDataService,private fb: FormBuilder) {
  }

  ngOnInit() {
      this.size = this.formDataService.getSize();
      console.log('Wohn- und Grundstücksfläche feature loaded!');
      
      this.testForm = new FormGroup({
        livingspace: new FormControl('', [ Validators.required, Validators.min(25), Validators.max(99999) ] ),
        space: new FormControl('', [ Validators.required, Validators.min(50), Validators.max(99999) ] )
      });
      
      this.offsetWidth = window.innerWidth;
  }

  save(form: any): boolean {
        if (!form.valid) {
            return false;
        }
      this.formDataService.setSize(this.size);
      return true;
  }

  goToNext(form: any) {
      if (this.save(form)) {
          // Navigate to the work page
          this.sendMessage('movetop');
          this.router.navigate(['/haus-step3']);
      }
  }

  goToPrevious(form: any) {
      this.sendMessage('movetop');
      this.router.navigate(['/haus-step1']);
  }

  // Send a message to the parent
  sendMessage(msg: string) {
    window.parent.postMessage(msg, '*');
   }

}
